import React from 'react';
import PropTypes from 'prop-types';
import Media from 'react-media';
import cn from 'classnames';

import { useUserState } from 'contexts/auth-context';
import t from 'utils/translateFunc';

import { BtnGreenTransparent32, TooltipForElement, BtnDel } from '../Elements';

import classes from './WidgetRelease.module.scss';

const WidgetRelease = ({
  date,
  option,
  title,
  sourse,
  textButton,
  onClick,
  className,
  handleDelRelease,
  isDeletable = true
}) => {
  const language = useUserState().user.language;

  return (
    <div
      className={cn(
        classes.widgetRelease,
        sourse && classes.widgetRelease_sourse,
        className
      )}
    >
      <div className={classes.headerBox}>
        <p className={classes.data}>{date}</p>
        {option && (
          <p className={classes.option}>
            {t('widgetRelease', 'OPTION', language)}
            {option}
          </p>
        )}
      </div>
      <h2 className={cn(classes.title, option && classes.titleForOptions)}>
        {title}
      </h2>
      <div
        className={cn(classes.footerBox, sourse && classes.footerBox_sourse)}
      >
        {sourse && (
          // rename this tag to <a>, at the time not href

          <p
            href={'#'}
            className={cn(classes.link, classes.hiddenText, classes.sourse)}
          >
            {sourse}
          </p>
        )}
        <BtnGreenTransparent32
          onClick={onClick}
          textButton={
            textButton ? textButton : t('widgetRelease', 'ADD', language)
          }
          className={cn(
            sourse && classes.buttonAdd,
            option && classes.buttonForOptions
          )}
        />
        <Media
          queries={{
            small: '(max-width: 1279px)'
          }}
        >
          {matches => (
            <>
              {option && isDeletable && (
                <TooltipForElement
                  text={t('tooltip', 'DEL_OPTION', language)}
                  isOpen={matches.small ? false : undefined}
                >
                  <BtnDel onClick={handleDelRelease} />
                </TooltipForElement>
              )}
            </>
          )}
        </Media>
      </div>
    </div>
  );
};

WidgetRelease.propTypes = {
  date: PropTypes.string,
  option: PropTypes.number,
  title: PropTypes.string,
  sourse: PropTypes.string,
  textButton: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string,
  handleDelRelease: PropTypes.func,
  isDeletable: PropTypes.bool
};

export default WidgetRelease;
